"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _ProductListItemPrice = _interopRequireDefault(require("@sprinx/react-com/ProductListItemPrice"));

var _ProductPriceElementDiscounPercent = _interopRequireDefault(require("@sprinx/react-com/ProductPriceElementDiscounPercent"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _ProductPriceElementPriceCvo = _interopRequireDefault(require("../ProductPriceElementPriceCvo/ProductPriceElementPriceCvo"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      alignSelf: 'center'
    },
    priceContainer: {
      display: 'flex'
    },
    percent: {
      marginLeft: theme.spacing(1)
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    price: (0, _defineProperty2.default)({
      fontSize: 30,
      fontWeight: 300
    }, theme.breakpoints.down('xs'), {
      fontSize: 18,
      fontWeight: 400
    })
  };
}, {
  name: 'ProductListItemCardProductPrice'
});

function ProductListItemCardProductPrice(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      prices = _ref.prices,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "currency", "prices", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _styles.useTheme)();
  var desktop = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  return /*#__PURE__*/_react.default.createElement(_ProductListItemPrice.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    product: product,
    currency: currency,
    ProductPriceProps: prices
  }), function (_ref2) {
    var discountPercent = _ref2.discountPercent,
        priceOriginalWithTax = _ref2.priceOriginalWithTax,
        priceWithTax = _ref2.priceWithTax;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.container
    }, priceWithTax > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, desktop && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.priceContainer
    }, /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
      currency: currency,
      value: priceOriginalWithTax,
      decoration: "strike",
      size: "small",
      color: "textPrimary"
    }), /*#__PURE__*/_react.default.createElement(_ProductPriceElementDiscounPercent.default, {
      currency: currency,
      value: discountPercent,
      className: classes.percent,
      size: "small",
      color: "textPrimary"
    })), /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
      currency: currency,
      value: priceWithTax,
      className: classes.price,
      color: "primary"
    })) : null);
  });
}

process.env.NODE_ENV !== "production" ? ProductListItemCardProductPrice.propTypes = {
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    percent: _propTypes.default.string,
    price: _propTypes.default.string,
    priceContainer: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  prices: _propTypes.default.shape({}),
  product: _propTypes.default.shape({}).isRequired
} : void 0;
ProductListItemCardProductPrice.defaultProps = {
  classes: undefined,
  className: undefined,
  currency: undefined,
  prices: undefined
};
var _default = ProductListItemCardProductPrice;
exports.default = _default;